"use client";

// src/collapsible.ts
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
var Collapsible = CollapsiblePrimitive.Root;
var CollapsibleTrigger2 = CollapsiblePrimitive.CollapsibleTrigger;
var CollapsibleContent2 = CollapsiblePrimitive.CollapsibleContent;

export {
  Collapsible,
  CollapsibleTrigger2 as CollapsibleTrigger,
  CollapsibleContent2 as CollapsibleContent
};
